import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: 600;\n  margin: 0 10px;\n\n  &:hover {\n    color: ', ';\n  }\n\n  ', '\n\n  ', '\n'], ['\n  color: ', ';\n  font-weight: 600;\n  margin: 0 10px;\n\n  &:hover {\n    color: ', ';\n  }\n\n  ', '\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      color: ', ';\n      pointer-events: none;\n    '], ['\n      color: ', ';\n      pointer-events: none;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      color: ', ';\n    '], ['\n      color: ', ';\n    ']);

import styled, { css } from 'styled-components';

export var StyledButton = styled.button(_templateObject, function (props) {
  return props.theme.dormifyGrey;
}, function (props) {
  return props.theme.dormifyPink;
}, function (_ref) {
  var disabled = _ref.disabled,
      theme = _ref.theme;
  return disabled && css(_templateObject2, theme.dormifyGrey);
}, function (_ref2) {
  var active = _ref2.active,
      theme = _ref2.theme;
  return active && css(_templateObject3, theme.dormifyBlack);
});